import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { baseStyles } from "./base.styles";
import { Colors } from "theme/colors";

interface InputProps {
  $uppercase?: boolean;
  $hover: boolean;
  $focus: boolean;
}

export const StyledInput = styled.input<InputProps>`
  border-radius: 0.325rem;
  width: 100%;
  outline: none;
  font-size: 0.9375rem;
  height: 2.47rem;

  ${baseStyles};
  cursor: pointer;
  &:disabled {
    cursor: default;
  }

  box-shadow: 0 0.294rem 0.59rem 0 rgba(0, 0, 0, 0.2) inset;

  // hover styles
  ${(props) =>
    props.$hover &&
    css`
      background-color: ${Colors.LIGHT_GRAY};
    `}

  // focus styles
  ${(props) =>
    props.$focus &&
    css`
      background-color: ${Colors.WHITE};
      border: 0.18rem solid ${Colors.MID_BLUE};
    `}

    // special case: uppercase
  ${(props) =>
    props.$uppercase &&
    css`
      text-transform: uppercase;
    `}
`;

export const StyledInputContainer = styled.div`
  position: relative;
`;
